export const routers = {
  coaches_clients: "/coaches&clients",
  organizations: '/organizations',
  clientProfile: '/client-profile/:id'
};
